wbApp.filter('attendanceType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_VAL_REGISTERED');
            case 1:
                return $translate.instant('TXT_VAL_ONEOFF');
            case 2:
                return $translate.instant('TXT_VAL_AMEND');
            case 3:
                return $translate.instant('TAX_VAL_PREVIEW');
        }        
    };
}]);